"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.esCountry = void 0;
var _utils = require("../utils");
var _companyNumber = require("../../companyNumber");
// i18next-extract-mark-ns-start Countries

var esCountry = exports.esCountry = function esCountry(t) {
  return {
    id: 'ES',
    name: t('Spain'),
    flag: '🇪🇸',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      return (zipcode === null || zipcode === void 0 ? void 0 : zipcode.length) === 5;
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 28001 or 08001',
    phonePrefix: '34',
    phoneLength: 9,
    pricingVersion: 14,
    timezone: 'Europe/Madrid',
    currency: 'EUR',
    companyNumber: {
      label: _companyNumber.labels.ES,
      checker: _companyNumber.checkers.ES,
      placeholder: 'A15022510'
    }
  };
};